import React, { Component } from "react";
import "./style.css";

class OrButton extends Component {
    render() {
        return (
            <div>
                <hr className="or_button__orHr" />
                <button type="button" className="or_button__orBtn">
                    או
                </button>
            </div>
        );
    }
}
export default OrButton;
